/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ShowCurrentMonthOnly4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * @class ShowCurrentMonthOnly4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.ShowCurrentMonthOnly4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.ShowCurrentMonthOnly4STBehavior.prototype */ {
      __name: "ShowCurrentMonthOnly4STBehavior",

      usedStyleAttributes: ["showCurrentMonthOnly"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const widget = controller.getWidget();
        if (widget?.setShowCurrentMonthOnly) {
          const showCurrentMonthOnly = controller.getAnchorNode().getStyleAttribute("showCurrentMonthOnly");
          widget.setShowCurrentMonthOnly(this.isSAYesLike(showCurrentMonthOnly));
        }
      }
    };
  });
});
